import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(loadSequence),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(sequenceSagas);

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { GaiaApolloClient } from '../../gaia-data/apolloClient';
import { SequenceQuery } from '../apollo/sequence-graphql';
import { LOAD_SEQUENCE, sequenceActions } from './sequence-reducer';
import { stepExpertModel } from '../../step-expert/step-expert-model';
import { userSelectors } from '../../user/redux/user-reducer';
import { getErrorHandler } from '../../gaia-data/init';

// action.payload should have a queryVars member like this:
//   {
//      courseId: some-course-id,
//      sequenceId: some-sequence-id,
//      sequenceSlug: some-sequence-slug,
//      locale: user-ui-language
//    }
// only one of sequenceId or sequenceSlug is necessary, and locale is only
//  used to localize the title of the returned sequence
//
function loadSequence(action) {
  var sequenceResponse, sequenceIdentifier, sequence, userLearningLanguage;
  return _regeneratorRuntime.wrap(function loadSequence$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(GaiaApolloClient.query, {
            query: SequenceQuery,
            variables: action.payload.queryVars
          });

        case 2:
          sequenceResponse = _context.sent;

          if (sequenceResponse.data.sequence) {
            _context.next = 9;
            break;
          }

          // could request either with slug or id so report back with what was used
          sequenceIdentifier = action.payload.queryVars.sequenceSlug;

          if (!sequenceIdentifier) {
            sequenceIdentifier = action.payload.queryVars.sequenceId;
          }
          _context.next = 8;
          return call(getErrorHandler(), { message: 'sequence not available: ' + sequenceIdentifier });

        case 8:
          return _context.abrupt('return', _context.sent);

        case 9:
          sequence = sequenceResponse.data.sequence;
          // filter out all expert-grading activities for LOTE until we have graders for that

          _context.next = 12;
          return select(userSelectors.getLearningLanguage);

        case 12:
          userLearningLanguage = _context.sent;

          if (!userLearningLanguage.includes('en-')) {
            sequence.activities = sequence.activities.filter(function (activity) {
              return !stepExpertModel.isExtendedSpeaking(activity.steps[0]) && !stepExpertModel.isExtendedWriting(activity.steps[0]);
            });
          }
          _context.next = 16;
          return put(sequenceActions.setSequence(sequence));

        case 16:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

export function sequenceSagas() {
  return _regeneratorRuntime.wrap(function sequenceSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(LOAD_SEQUENCE, loadSequence);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}